import React from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@mui/material";

import { Button } from "../buttons";

import { CommonDialog, CommonDialogTitle, CommonDialogContent, CommonDialogActions } from "./common-dialog.jsx";

import "./style.less";

const SuccessDialog: React.FC<{ open: boolean; onClose: () => void, title: string, text: string }> = ({ open, onClose, title, text }) => {

    return (
        <CommonDialog open={!!open} className="succes-save-data-dialog">
            <CommonDialogTitle withoutCloseIcon={false} title={title} onClose={onClose} />

            <CommonDialogContent>
                <Typography className="succes-save-data-dialog-message">
                    {text}
                </Typography>
            </CommonDialogContent>

            <CommonDialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                >
                    <FormattedMessage id="common.btn-close" />
                </Button>
            </CommonDialogActions>
        </CommonDialog>
    );
};

export default SuccessDialog;
